import { createSubscriptionHook } from '~/shared/providers/api';

export const usePurchaseLoadChangesSubscription = createSubscriptionHook(
  'trade.purchaseLoadChanges',
  (params: { ids: string[] }) => ({
    tradePurchaseLoadChanges: {
      __args: { ids: params.ids },
      id: true,
      version: true,
    },
  }),
  {
    select: ({ tradePurchaseLoadChanges }) => tradePurchaseLoadChanges,
  },
);
